import { lazy } from "react";
import Loadable from "components/Loadable";

const ProminentMemberList = Loadable(
  lazy(() => import("features/prominentMember/components/List"))
);
const ProminentMemberPage = Loadable(
  lazy(() => import("features/prominentMember/components/Page"))
);

const routes = {
  path: "prominentMember",
  children: [
    { path: "", element: <ProminentMemberList /> },
    { path: "add", element: <ProminentMemberPage /> },
    { path: "edit/:prominentMemberID?", element: <ProminentMemberPage /> },
  ],
};

export default routes;
